
import BrandManagement from "@/components/operation/BrandManagement";
// import StoreTypeManagement from "@/components/operation/StoreTypeManagement";
export default {
  components: {
    BrandManagement,
    // StoreTypeManagement,
  },
  data() {
    return {
      // tabs: "brandManagement",
    }
  },
}
